import {Component, OnInit} from '@angular/core';
import {PopoverRef} from '../popover/popover-ref';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import zxcvbnCommonPackage from '@zxcvbn-ts/language-common';
import {zxcvbn, zxcvbnOptions} from '@zxcvbn-ts/core';
import {GTMWrapperService} from '../../services/gtmwrapper.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

    submitDisabled = true;
    oldPassword = '';
    firstNewPassword = '';
    secondNewPassword = '';

    form = new FormGroup({
        oldPassword: new FormControl('', [Validators.required]),
        newPassword1: new FormControl('', [Validators.required]),
        newPassword2: new FormControl('', [Validators.required]),
    });

    passwordRegex = /^(?=.*?[A-Z])(?!.*[ßüöäÜÖÄ])(?=.*?[0-9]).{8,}$/;
    currentPasswordScore = 0;

    private zxcvbnLocalOptions = {
        graphs: zxcvbnCommonPackage.adjacencyGraphs,
        dictionary: {
            ...zxcvbnCommonPackage.dictionary,
        },
    };

    constructor(public popoverRef: PopoverRef,
                private gtm: GTMWrapperService) {
        if (this.popoverRef) {
            this.initializePopoverData();
        }
    }

    ngOnInit() {
        this.initialize();
    }


    close(value = false): void {
        this.popoverRef.close(value);
    }


    submitChange(): void {
        this.popoverRef.close(
            {
                success: true,
                values: {
                    oldPassword: this.oldPassword,
                    firstNewPassword: this.oldPassword,
                    secondNewPassword: this.oldPassword,
                }
            }
        );
    }


    determinePasswordScoreRatingText(): string {
        if (this.currentPasswordScore <= 2) {
            return 'unsicher';
        } else if (this.currentPasswordScore === 3) {
            return 'sicher';
        }
        return 'sehr sicher';
    }


    determinePasswordStrengthIndicatorColor(index): string {
        if (index <= this.currentPasswordScore) {
            return this.determinePasswordStrengthColor();
        }
        return 'transparent';
    }


    determinePasswordStrengthColor(): string {
        const colors = ['#b80000', '#ea1b0a', '#f05548', '#e3e000', '#1ea2b1'];
        return colors[this.currentPasswordScore];
    }


    private validateInput(): void {
        // tslint:disable-next-line:max-line-length
        if (this.oldPassword === '' || this.firstNewPassword === '' || this.secondNewPassword === '') {
            this.submitDisabled = true;
            return;
        }
        if (this.firstNewPassword === this.secondNewPassword) {
            this.submitDisabled = !this.passwordRegex.test(this.firstNewPassword);
            return;
        }
        this.submitDisabled = true;
    }


    private initializePopoverData() {
        this.popoverRef.overlay.backdropClick().subscribe(() => {
            this.close(false);
        });
    }

    private initialize(): void {
        zxcvbnOptions.setOptions(this.zxcvbnLocalOptions);
        this.form.valueChanges.subscribe((valueChange) => {
            this.oldPassword = valueChange.oldPassword;
            this.firstNewPassword = valueChange.newPassword1;
            if (this.firstNewPassword && this.firstNewPassword !== '') {
                this.currentPasswordScore = zxcvbn(this.firstNewPassword).score;
            }
            this.secondNewPassword = valueChange.newPassword2;
            this.validateInput();
        });
    }


    /// ============================================================================================
    /// GTM STUFF
    /// ============================================================================================
    private trackViewAppearedEvent(): void {
        this.gtm.trackEvent({
            event: 'start',
            eventCategory: 'interaction',
            eventAction: 'start',
            journeyId: 'contact data',
            toolId: 'contact data',
            elementId: 'contact data',
            stepId: 'edit password'
        });
    }
}
